import React from "react";
import {Button, Timeline} from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { formatMoney, formatExchangeRate, displayNumberWithComma } from "utils/utils";
import "./TrackAndTracePanel.scss";
import {downloadOrderReceipt} from "../api/api";

import TimelineOrderPendingApproval from "components/TimelineOrderPendingApproval";
import TimelineOrderBooking from "components/TimelineOrderBooking";
import TimelineOrderProcessing from "components/TimelineOrderProcessing";
import TimelineOrderCanceled from "components/TimelineOrderCanceled";
import TimelineOrderCompleted from "components/TimelineOrderCompleted";
import TimelineOrderClosed from "./TimelineOrderClosed";
import TimelineOrderReturned from "./TimelineOrderReturned";

export default class TrackAndTracePanel extends React.Component {
  render() {
    return (
      <div>
          {(this.props.order.orderStatus === "PENDING_APPROVAL"  || this.props.order.orderStatus === "PENDING_AUTHORIZE" ) && (
              <TimelineOrderPendingApproval {...this.props} />
          )}
        {(this.props.order.orderStatus === "BOOKING" || this.props.order.orderStatus === "DRAFT") && (
          <TimelineOrderBooking {...this.props} />
        )}
        {(this.props.order.orderStatus === "PROCESSING" || this.props.order.orderStatus === "RECEIVED") && (
          <TimelineOrderProcessing {...this.props} />
        )}
        { (this.props.order.orderStatus === "CANCELED") && (
          <TimelineOrderCanceled {...this.props} />
        )}
        { (this.props.order.orderStatus === "RETURNED") && (
            <TimelineOrderReturned {...this.props} />
        )}
        {this.props.order.orderStatus === "COMPLETED" && (
          <TimelineOrderCompleted {...this.props} />
        )}
        {this.props.order.orderStatus === "CLOSED" && (
            <TimelineOrderClosed {...this.props} />
        )}
      </div>
    );
  }
}











function NotCompletedItemIcon() {
  return <div className="timeline-dot-not-completed" />;
}

function RedItemIcon() {
  return <div className="timeline-dot-red" />;
}
